import Customer from '../models/Customer';
import CustomerAddress from '../models/CustomerAddress';

const PHONE_REGEXP = /^[+][0-9]{5,15}$/;
const EMAIL_REGEXP = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;
const LOGIN_NAME_REGEXP = /^(?:[A-Za-z1-9]\w*|0)$/;

export const isValidPhone = (phone: string | undefined, couldBeEmpty: boolean): boolean => {
  if (phone === '' || phone === undefined) {
    return couldBeEmpty;
  }
  return PHONE_REGEXP.test(phone);
};

export const isValidEmail = (email: string, couldBeEmpty: boolean): boolean => {
  if (email === '') {
    return couldBeEmpty;
  }
  return EMAIL_REGEXP.test(email);
};

export const isValidCustomer = (customer: Customer): boolean =>
  customer.name !== '' &&
  customer.registrationCode !== '' &&
  customer.country !== '' &&
  isValidPhone(customer.phone, true) &&
  isValidEmail(customer.email, false) &&
  customer.preferredLanguage !== '';

export const isAllFieldsEmpty = (address: CustomerAddress): boolean => JSON.stringify({
  streetHouse: address.streetHouse,
  country: address.country,
  city: address.city,
  postalCode: address.postalCode,
}) === JSON.stringify({
  streetHouse: '',
  country: '',
  city: '',
  postalCode: '',
});

export const isValidAddress = (address: CustomerAddress): boolean => {
  if (isAllFieldsEmpty(address)) {
    return true;
  }

  return address.streetHouse !== '' &&
    address.city !== '' &&
    address.country !== '' &&
    address.postalCode !== '';
};

export const isValidLoginName = (loginName: string): boolean => loginName.length >= 6 &&
  LOGIN_NAME_REGEXP.test(loginName);
